<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2026-08-27 14:11:08
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2026-08-27 14:17:40
 * @FilePath: \qctsw-vue\packages\app\src\components\util\UtilComplaintScore.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang="ts">
import { getComplaintStatus, getScoreText } from '@/shared/function'
import type { SCORE } from '~/shared/constants'

const props = withDefaults(
  defineProps<{
    code?: keyof typeof SCORE
    statusList?: number[]
    statusText?: string
    bgColor?: string
  }>(),
  {
    code: '0',
  },
)
</script>

<template>
  <span class="status flex-shrink-0 leading-1.5em" :class="[`status-${code}`]">{{
    getScoreText(props.code)
  }}</span>
</template>

<style lang="scss" scoped>
.status {
  --uno: rounded px-2 py-1 text-white bg-gray-4 text-2.5 mr-1 text-center;
  vertical-align: 0.15em;
  &-2 {
    --uno: bg-green-5;
  }
  &-1 {
   --uno: bg-blue-5 ;
  }
  &-0 {
    background-color: #7d66ec;
  }
  &--1 {
    background-color: #ff7649;
  }
  &--2 {
    background-color: #ec1313;
  }
}
</style>
